import React from 'react';
import * as Icons from 'lucide-react';
import { MapPin, Instagram, Globe, ArrowRight } from 'lucide-react';
import Logo from '@/components/public/Logo';
import { DEFAULT_SITE_CONTENT, mergeContent } from '@/constants/defaultSiteContent';

const Footer = ({ content, brand, onCta }) => {
  const c = mergeContent(DEFAULT_SITE_CONTENT.footer, content || {});
  const socialFallbacks = [Instagram, Globe];

  return (
    <footer id="contact" className="bg-[#F5F0E6] border-t border-black/5">
      <div className="max-w-[1360px] mx-auto px-4 sm:px-6 py-8 sm:py-10 grid md:grid-cols-[auto_1fr_auto] gap-6 md:gap-10 items-center">
        <Logo brand={brand} showWordmark tagline />
        <div className="flex flex-wrap items-center gap-6 md:gap-10 text-[#141414]">
          <FooterItem icon={MapPin}>
            <span className="block text-sm leading-tight">{c.location_line1}</span>
            <span className="block text-sm leading-tight">{c.location_line2}</span>
          </FooterItem>
          {(c.socials || []).map((s, i) => {
            const IconComp = Icons[s.icon] || socialFallbacks[i] || Globe;
            return (
              <FooterItem key={i} icon={IconComp}>
                <a href={s.url} target="_blank" rel="noreferrer" className="text-sm hover:text-[#0F2E23]">{s.label}</a>
              </FooterItem>
            );
          })}
        </div>
        <button onClick={onCta} className="pg-glossy inline-flex items-center gap-3 bg-[#0F2E23] hover:bg-[#153F30] text-[#F5F0E6] pl-5 pr-4 py-3 rounded-md text-[11px] tracking-[0.22em] font-semibold shadow-sm transition-colors">
          {c.cta_label} <ArrowRight className="w-4 h-4" />
        </button>
      </div>
      <div className="border-t border-black/5">
        <div className="max-w-[1360px] mx-auto px-4 sm:px-6 py-3 text-[10px] tracking-[0.24em] text-[#141414]/55 text-center">{c.copyright}</div>
      </div>
    </footer>
  );
};

const FooterItem = ({ icon: Icon, children }) => (
  <div className="inline-flex items-start gap-2">
    <span className="inline-flex w-7 h-7 shrink-0 items-center justify-center rounded-full bg-[#0F2E23] text-[#F5C86A]"><Icon className="w-3.5 h-3.5" /></span>
    <div className="text-[#141414]">{children}</div>
  </div>
);

export default Footer;
